/*  ===================================
 *  FREE SHIPPING TRESHOLD WIDGET
 *  - Simple widget that adds a progress bar indicating how far they are for free shipping
 *  ===================================
 */

(function(w,d){
    const settings = {
        container: 'FSTContainer',
        progress_bar: 'FSTBar',
        message: 'FSTMessage',
        message_error: 'Please enter a target goal amount in the Theme Settings > Cart > Free Shipping Threshold'
    }
    const container = d.getElementById(settings.container);
    let data;
    let exchange_rate = Shopify.currency.rate;

    function initData() {
        const dataset = container.dataset.settings ?? new Object;
        if (Object.keys(dataset).length === 0) return;
        data = JSON.parse(dataset);
    }

    function fetchCartData() {
        fetch((window.theme?.routes?.cart ? window.theme.routes.cart : '/cart.js'), {
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(response => response.json())
        .then(data => calculateShipping(data));
    }

    function renderElements() {
        const labelHTML = d.createElement('label')
        labelHTML.setAttribute('for', settings.progress_bar)
        // labelHTML.textContent = 'Free shipping progress'

        const progressBarHTML = d.createElement('progress')
        progressBarHTML.id = settings.progress_bar
        progressBarHTML.setAttribute('max', 100)
        progressBarHTML.setAttribute('value', 0)
        progressBarHTML.dataset.target = data.target ?? null

        const progressBarWrapper = d.createElement('div')
        progressBarWrapper.classList.add('fst-progress-bar-wrapper')
        progressBarWrapper.dataset.target = data.target ?? null
        progressBarWrapper.appendChild(progressBarHTML)

        const messageHTML = d.createElement('div')
        messageHTML.id = settings.message
        messageHTML.classList.add('fst-message')

        container.appendChild(messageHTML);
        container.appendChild(labelHTML);
        container.appendChild(progressBarWrapper);
    }

    function calculateShipping(cartJson) {
        const target = data.target ? parseFloat(data.target) : null;
        let cart_total = (cartJson.total_price ? cartJson.total_price : cartJson.final_price) / 100;

        if (data.shop_currency != data.cart_currency) {
            cart_total = cart_total / exchange_rate;
        }

        const progress_value = (cart_total / target) * 100;
        const remaining = target - cart_total;
        let message = '';

        if (target) {
            // Set value of progress bar
            if (progress_value >= 100){
                d.getElementById(settings.progress_bar).setAttribute('value', 100);
                d.getElementById(settings.progress_bar).parentElement.setAttribute('value', 100);
            }
            else {
                d.getElementById(settings.progress_bar).setAttribute('value', progress_value ? progress_value : 0);
                d.getElementById(settings.progress_bar).parentElement.setAttribute('value', progress_value ? progress_value : 0);
            }

            message =
                remaining >= target ? data.message_default.replace('[target]', `$${target}`) :
                remaining <= 0 ? data.message_success : data.message_ongoing.replace('[remaining]', `$${remaining ? remaining.toFixed(2) : target}`);

        }
        else
            message = settings.message_error

        // Display message
        d.getElementById(settings.message).innerHTML = message;
    }

    function init() {
        if (!container) return;

        initData();
        renderElements();
        fetchCartData();

        // Listeners for product added and cart updates
        ['cart:updated', 'ajaxProduct:added'].forEach(evt =>
            d.addEventListener(evt, fetchCartData, false)
        );
    }

    init();
})(window, document)